import { render, staticRenderFns } from "./cr_show_body_div.vue?vue&type=template&id=f6c5b72e&"
import script from "./cr_show_body_div.vue?vue&type=script&lang=js&"
export * from "./cr_show_body_div.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6c5b72e')) {
      api.createRecord('f6c5b72e', component.options)
    } else {
      api.reload('f6c5b72e', component.options)
    }
    module.hot.accept("./cr_show_body_div.vue?vue&type=template&id=f6c5b72e&", function () {
      api.rerender('f6c5b72e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/crud/cr_show_body_div.vue"
export default component.exports